module.exports = __webpack_public_path__ + "static/media/tempo_ativo.2e5e41af.svg";